import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import InquiryService from "../../services/inquiryService";
import { richtextToHtml } from "../../utils/richtextUtil";
import Utils from "../../utils/utils";
import NetworkImage from "../../components/image/NetworkImage";
import { Fancybox } from "@fancyapps/ui";
import { replaceUrlCdn } from "../../utils/common";
const DetailInquiry: React.FC = () => {
  const { t } = useTranslation();
  const categories = [
    { lable: t("Pass"), value: "PASS" },
    { lable: t("Ticket"), value: "TICKET" },
    { lable: t("Tour"), value: "TOUR" },
    { lable: t("Musical"), value: "MUSICAL" },
    { lable: t("E-sim"), value: "SIM" },
    { lable: t("Cancel/ refund policy"), value: "CANCEL" },
    { lable: t("Upgrade process"), value: "UPGRADE" },
  ];
  const [loading, setLoading] = useState(false);
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();
  const { data: inquiryData } = useQuery<any>({
    queryKey: ["inquiry", id],
    queryFn: () => {
      return InquiryService.getInquiry(id || "").finally(() => {
        queryClient.invalidateQueries("unReadInquiry");
      });
    },
    enabled: !!id,
  });
  const renderCategory = () => {
    return (
      categories.find((category) => category.value === inquiryData.category)
        ?.lable || ""
    );
  };
  const handleDelete = () => {
    setLoading(true);
    InquiryService.deleteInquiry(Number(id))
      .then(() => {
        window.location.href = "/my-inquiry";
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const openFullScreen = (index?: number) => {
    // setIsFullScreen(true);
    if (inquiryData.images.length === 0) return;
    // Wrap in requestAnimationFrame to prevent ResizeObserver loop warning
    requestAnimationFrame(() => {
      Fancybox.show(
        inquiryData.images.map((image: any) => ({
          src: replaceUrlCdn(image.path),
          type: "image",
        })),
        {
          Thumbs: false,
          Toolbar: false,
          closeButton: "auto",
          hideScrollbar: true,
          startIndex: index || 0,
        },
      );
    });
  };

  const renderImages = () => {
    if (!inquiryData.images || inquiryData.images.length === 0) return null;
    return (
      <div className="border-blue_gray-50 rounded-[0.625rem] border border-solid p-[1.25rem] shadow-sm">
        <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
          {inquiryData.images.map((image: any, index: number) => (
            <NetworkImage
              onClick={() => openFullScreen(index)}
              key={index}
              className="h-[7.50rem] w-full cursor-pointer rounded-lg object-cover"
              src={image.path}
              alt={`Inquiry ${index + 1}`}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    );
  };

  if (!inquiryData) {
    return null;
  }

  return (
    <div className="mx-auto flex w-full max-w-[84.13rem] flex-col items-start lg:pl-[15.00rem] lg:pr-[3.50rem]">
      <div className="flex w-full flex-col gap-[1.88rem] rounded-[1.25rem] bg-white p-[1.88rem] lg:w-[76%]">
        {/* Header Section */}
        <div className="flex items-start justify-center">
          <div className="flex flex-1 flex-col items-start gap-[0.63rem] self-center">
            <h1 className="text-gray-900_01 text-[1.50rem] font-semibold">
              {inquiryData.title}
            </h1>
            <div className="flex flex-wrap items-center gap-[0.81rem] self-stretch">
              <p className="text-gray-900_01 text-[1.00rem] font-normal">
                {t("Post date: ")}
                {Utils.formatDate(
                  new Date(inquiryData.createdAt),
                  "YYYY.MM.DD",
                )}
              </p>
              <p className="text-gray-900_01 flex items-center justify-center rounded-[0.75rem] bg-gray-50 px-[1.00rem] text-[1.00rem] font-normal">
                {renderCategory()}
              </p>
            </div>
          </div>
          {/* <button
            onClick={handleDelete}
            disabled={loading}
            className="min-w-[3.13rem] flex flex-row items-center justify-center text-center cursor-pointer whitespace-nowrap rounded-[0.3125rem] h-[1.88rem] px-[0.13rem] text-[0.88rem] border border-gray-500 text-gray-900_01"
          >
            {loading ? t("Deleting...") : t("Delete")}
          </button> */}
        </div>

        {/* Content Section */}
        <div className="border-blue_gray-50 rounded-[0.625rem] border border-solid p-[1.25rem] shadow-sm">
          <p
            className="text-gray-900_01 text-[1.00rem] font-normal leading-[1.31rem]"
            dangerouslySetInnerHTML={{
              __html: inquiryData.inquiry.replace(/\n/g, "<br />"),
            }}
          ></p>
        </div>

        {/* Images Section */}
        {renderImages()}

        {/* Reply Section */}
        {inquiryData.replyDTOS?.length > 0 && (
          <div className="flex flex-col gap-[1.00rem] rounded-[1.25rem] border border-solid border-gray-50 bg-gray-50 p-[1.88rem]">
            {inquiryData.replyDTOS.map((reply: any, index: number) => (
              <div key={index} className="flex flex-col gap-[1.00rem]">
                <p className="font-notosans flex w-full flex-col gap-2 text-[0.88rem] font-normal leading-[0.88rem] text-gray-900">
                  <span className="font-semibold">
                    {reply.author || t("Tamice Manager")}
                    <br />
                  </span>
                  <span>
                    {t("Reply date: ")}
                    {Utils.formatDate(reply.date, "YYYY.MM.DD HH:mm")}
                  </span>
                </p>
                <p
                  className="text-gray-900_01 response-inquiry text-[1.00rem] font-normal leading-[1.31rem]"
                  dangerouslySetInnerHTML={{
                    __html: richtextToHtml(reply?.post?.richtext),
                  }}
                ></p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailInquiry;
